import { BaseIndexFieldModel, ReminderConfigModel } from '../../data';
import { WhatsAppTemplateParamModel } from "../../data/whatsapp/whatsapp-template-param.model";

export interface TransactionalEmailTypeRequestModel {
  name: string;
  code: string | null;
  csvSeparator: string;

  emailFrom: string;
  emailFromName: string;
  mailServerId?: number | null;
  emailSubject: string;
  emailContent: string;
  emailMjmlContent: string;

  sendSms: boolean;
  smsContent?: string;

  passwordProtected: boolean;
  hasAttachment: boolean;

  archive: boolean;
  autoPurge: boolean;
  autoPurgeByDays: number;

  whatsAppTemplateName: string | null;
  htmlTemplateName?: string;
  multipleAttachments?: boolean;
  txtSeparator?: string;
  hasHtmlFile?: boolean;
  hasReminder?: boolean;
  hasAcknowledgement?: boolean;
  acknowledgementExpiryDays?: number | null;
  hasCustomAcknowledgeUrl?: boolean;
  customAcknowledgeUrl?: string | null;
  customAcknowledgeUrlSecret?: string | null;
  hasCustomExpiryUrl?: boolean;
  customExpiryUrl?: string | null;
  hasCustomLandingPage?: boolean;
  customSuccessLandingUrl?: string | null;
  customFailLandingUrl?: string | null;

  indexFields: BaseIndexFieldModel[];
  whatsAppTemplateParams: WhatsAppTemplateParamModel[];
  reminderConfigs?: ReminderConfigModel[];
  isTest?: boolean;
  test?: boolean;
}
